export enum AccountSelectionActionTypes {
  SET_SELECTED_ACCOUNT = 'SET_SELECTED_ACCOUNT',
  SET_AVAILABLE_ACCOUNTS = 'SET_AVAILABLE_ACCOUNTS',
  UPDATE_ACCOUNT_SELECTION = 'UPDATE_ACCOUNT_SELECTION',
  CLEAR_ACCOUNT_SELECTION = 'CLEAR_ACCOUNT_SELECTION',
  ACCOUNT_SELECTION_LOADING = 'ACCOUNT_SELECTION_LOADING',
  ACCOUNT_SELECTION_ERROR = 'ACCOUNT_SELECTION_ERROR',
  ACCOUNT_SELECTION_CLEANUP = 'ACCOUNT_SELECTION_CLEANUP',
}
